export const START_FETCH_MEDIA_MAIN_PHOTO = 'START_FETCH_MEDIA_MAIN_PHOTO';
export const SUCCESS_FETCH_MEDIA_MAIN_PHOTO = 'SUCCESS_FETCH_MEDIA_MAIN_PHOTO';
export const ERROR_FETCH_MEDIA_MAIN_PHOTO = 'ERROR_FETCH_MEDIA_MAIN_PHOTO';

export const START_FETCH_MEDIA_ATTACHMENTS = 'START_FETCH_MEDIA_ATTACHMENTS';
export const SUCCESS_FETCH_MEDIA_ATTACHMENTS = 'SUCCESS_FETCH_MEDIA_ATTACHMENTS';
export const ERROR_FETCH_MEDIA_ATTACHMENTS = 'ERROR_FETCH_MEDIA_ATTACHMENTS';
